function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.34273 4.4541H12.2273C12.6854 4.4541 13.1247 4.63608 13.4486 4.96001C13.7726 5.28393 13.9545 5.72327 13.9545 6.18137V9.06592L14.8182 9.92956L20 6.18137V14.8177M13.9545 13.9541V14.8177C13.9545 15.2758 13.7726 15.7152 13.4486 16.0391C13.1247 16.363 12.6854 16.545 12.2273 16.545H2.72727C2.26917 16.545 1.82983 16.363 1.50591 16.0391C1.18198 15.7152 1 15.2758 1 14.8177V6.18137C1 5.72327 1.18198 5.28393 1.50591 4.96001C1.82983 4.63608 2.26917 4.4541 2.72727 4.4541H4.45455L13.9545 13.9541Z",
  fill: "none",
  stroke: "inherit",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 1L20 20",
  fill: "none",
  stroke: "inherit",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgVideoOff = function SvgVideoOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    stroke: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video-off.09c047e5.svg";
export { ForwardRef as ReactComponent };